const PanelContainer = {
  baseStyle: {
    p: "30px 15px",
    minHeight: "100vh",
  },
};

export const PanelContainerComponent = {
  components: {
    PanelContainer,
  },
};
